module.exports = __webpack_public_path__ + "static/media/Hajky.48553391.md";